<template>
  <TjingSidebar
    :show="show"
    @close="closeSidebar()"
    :width="{
      mobile: 'calc(100% - 35px)',
      tablet: '400px',
      laptop: '400px',
      desktop: '400px',
    }"
  >
    <template v-slot:header>
      <div class="sidebar-header">
        <p class="sidebar-title">
          <b>{{ team.name }}</b>
        </p>
        <span @click="closeSidebar()">
          <Crossmark />
        </span></div
    ></template>
    <template v-slot:body>
      <div class="sidebar-body">
        <div class="team-player" v-for="member in team.teamPlayers">
          <div class="left">
            <UserProfileAvatar
              size="L"
              :profileImageUrl="member.user.profile.profileImageUrl"
              :initials="
                member.user.firstName.charAt(0) + member.user.lastName.charAt(0)
              "
            />
          </div>
          <div class="right">
            <p class="user-name">
              <b>{{ member.user.firstName }} {{ member.user.lastName }}</b>
            </p>
            <p class="club" v-if="member.user.profile.mainClubName">
              {{ member.user.profile.mainClubName }}
            </p>
            <p class="pdga">
              PDGA No:
              <b v-if="member.user.profile.pdgaNumber">{{
                member.user.profile.pdgaNumber
              }}</b>
              <span v-else>-</span>
            </p>
            <p class="rating">
              Rating:
              <b v-if="member.user.profile.pdgaRating">{{
                member.user.profile.pdgaRating
              }}</b>
              <span v-else>-</span>
            </p>

            <router-link
              class="profile"
              :to="{ name: 'public-user', params: { userId: member.user.id } }"
              ><p>View profile</p></router-link
            >
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="sidebar-footer">
        <button
          class="previous"
          :disabled="playerIndex === 0"
          @click="playerIndex--"
        >
          <Arrow :color="playerIndex === 0 ? 'sleet' : 'midnight'" />Previous
        </button>
        <button
          class="next"
          :disabled="playerIndex === teams.length - 1"
          @click="playerIndex++"
        >
          Next<Arrow :color="playerIndex === teams.length - 1" />
        </button>
      </div>
    </template>
  </TjingSidebar>
</template>

<script>
import Crossmark from '@/assets/icons/Crossmark'
import Arrow from '@/assets/icons/Arrow'
import TjingSidebar from '@/pages/TjingSidebar'
import UserProfileAvatar from '@/components/UIElements/UserProfileAvatar'
export default {
  name: 'TeamDetailsSidebar',
  props: ['show', 'startIndex', 'teams'],
  components: {
    TjingSidebar,
    Arrow,
    Crossmark,
    UserProfileAvatar,
  },
  data() {
    return {
      playerIndex: 0,
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.playerIndex = this.startIndex
        }
      },
    },
  },

  computed: {
    team() {
      return this.teams[this.playerIndex]
    },
  },
  methods: {
    closeSidebar() {
      this.$emit('close')
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

.team-player {
  display: flex;
  gap: 15px;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid $fog;
}

.user-name {
  font-size: 24px;
}
.club {
  font-size: 18px;
  margin-top: 8px;
  @include Gilroy-LightItalic;
}

.pdga,
.rating,
.country,
.profile {
  font-size: 18px;
  margin-top: 10px;

  span {
    color: $strom;
  }
}
.pdga {
  margin-top: 20px;
}

.profile p {
  font-size: 18px;
  margin-top: 10px;
}

.sidebar-header {
  border-bottom: 1px solid $fog;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 64px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  flex-direction: row;
  span {
    right: 12px;
    top: 15px;
    position: absolute;
    transition: all ease 0.3s;
    display: flex;
    padding: 12px;
    cursor: pointer;
    border-radius: 50%;
    svg {
      transition: all ease 0.3s;
    }
    &:hover {
      background: $mist;
    }
  }
}

.sidebar-body {
  padding-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  overflow: auto;
}
.sidebar-footer {
  border-top: 1px solid $fog;
  padding-top: 28px;
  padding-bottom: 28px;
  padding-left: 24px;
  padding-right: 24px;
  margin-top: auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.sidebar-title {
  font-size: 1.125rem;
  line-height: 1.6875rem;
}
.next {
  cursor: pointer;
  @include Gilroy-Bold;
  display: flex;
  gap: 8px;
  height: 48px;
  border-radius: 6px;
  outline: none;
  background-color: $midnight;
  border: 1px solid $midnight;
  transition: all ease 0.3s;
  color: white;
  &:hover {
    color: white;
    background-color: black;
    border: 1px solid black;
  }

  &:disabled {
    cursor: default;
    color: white;
    border: 1px solid $sleet;
    background-color: $sleet;
  }
}
.previous {
  cursor: pointer;
  @include Gilroy-Bold;
  display: flex;
  gap: 8px;
  height: 48px;
  border-radius: 6px;
  outline: none;
  background-color: transparent;
  border: 1px solid $midnight;
  transition: all ease 0.3s;
  &:hover {
    border: 1px solid black;
  }
  svg {
    transform: rotate(180deg);
  }
  &:disabled {
    cursor: default;
    color: $sleet;
    border: 1px solid $sleet;
  }
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
}
</style>
